import Toastr from "toastr";
window.toastr = Toastr;